import InternalForm from './Form';
import Input from './Input';

import useForm from '../../hooks/useForm';

const Form = InternalForm;
Form.useForm = useForm;
Form.Input = Input;

export default Form;